import axios from '@fs/zion-axios'
import { getUser } from '@fs/zion-user'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

export const tags = {
  RESOLVED: 'resolved',
  NON_SUPPORT: 'nonsupport',
}

/**
 * Get all tags the user has made
 * @param {Object} data Object containing data about the request
 * @param {String} data.cisId The CIS ID of the user to get all tags for
 * @returns {Promise} A Promise resolving to an axios response with the tag data
 */
export const getTagsMadeByUser = () => {
  return getUser().then(({ cisId }) =>
    axios({
      method: 'GET',
      url: `${serviceBaseUrl}/guests/${cisId}/tags`,
    })
  )
}
/**
 * Add a tag to be associated with a CIS ID
 * @param {Object} data Object containing data about the request
 * @param {String} data.cisId The CIS ID of the user adding the tag
 * @param {String} data.label The tag being added
 * @param {String} data.taggedRef The JID to be associated with the tag
 * @returns {Promise} A Promise resolving to an axios response that ends with a 204 on success
 */
export const addTag = ({ label, taggedRef }) => {
  return getUser().then(({ cisId }) =>
    axios({
      method: 'PUT',
      url: `${serviceBaseUrl}/guests/${cisId}/tags?label=${label}&taggedRef=${taggedRef}`,
    })
  )
}
/**
 * Remove a tag associated with a tagged CIS ID
 * @param {Object} data Object containing data about the request
 * @param {String} data.cisId The CIS ID of the user removing the tag
 * @param {String} data.taggedRef The JID associated with the tag being removed
 * @returns {Promise} A Promise resolving to an axios response that ends with a 204 on success
 */
export const removeTag = ({ taggedRef }) => {
  return getUser().then(({ cisId }) =>
    axios({
      method: 'DELETE',
      url: `${serviceBaseUrl}/guests/${cisId}/tags?taggedRef=${taggedRef}`,
    })
  )
}
